import React, {Component} from 'react';
import {Item, Segment, Rating, Button} from 'semantic-ui-react'

import moment from 'moment';

import axios from "axios";
// import moment from "../detail/detail";
class ReviewCard extends Component {
    constructor(props) {
        super();
        this.state = {
            house:props.house,
            review:props.review
        };
        this.onClickHandler = this.onClickHandler.bind(this);
    }


    onClickHandler(){
        console.log(this.state.review);
        const url = `http://node-express-env.yhwg8jeyei.us-west-2.elasticbeanstalk.com/api/reviews/${this.state.review._id}`;
        console.log(url);
        axios.delete(url).then((res)=>{
            console.log(res);
            let user = localStorage.getItem('user');
            let profile = JSON.parse(user);
            console.log(profile);
            profile.myReview = profile.myReview.filter(e => e !== this.state.review._id);
            console.log(profile);
            user = JSON.stringify(profile);
            localStorage.setItem('user', user);
            window.location = `${process.env.PUBLIC_URL}/users/profile`;
        }).catch((error) => {
            console.log(error);
        });
    }

    render() {
        return (
            <Segment className="review_card">
                <Item.Group>
                    <Item>
                        <Item.Image className="card_image" src={this.state.house.photo[0]} />
                        <Item.Content className="card_container">
                            <Item.Meta content={this.state.house.city + "·" + this.state.house.state} />
                            <Item.Header>{this.state.house.address}</Item.Header>
                            <Item.Description className="card_des">{"\"" + this.state.review.description + "\""}</Item.Description>
                            <Item.Extra>
                                <Button primary floated='left' onClick={this.onClickHandler}>
                                    Delete review
                                </Button>
                            </Item.Extra>
                        </Item.Content>
                        <Item.Content className="rating_info">
                            <Item.Meta content={moment(this.state.review.date).format('YYYY/MM/DD')} />
                            <Item.Header className="rating"><Rating defaultRating={Math.round(this.state.review.rating)} maxRating={5} disabled /></Item.Header>
                        </Item.Content>
                    </Item>
                </Item.Group>
            </Segment>
        );
    }
}

export default ReviewCard;